import { Box, Stack } from '@storyofams/react-ui';
import { Text, Button } from '~components';
import { Navigation } from '../Navigation';
import { NavigationLink } from '../Navigation/components/NavigationLink';

type TableProps = {
  label: string;
  tableLinks: TableLink[];
};

export type TableLink = {
  link: string;
  label: string;
};

export const TableOfContents = ({ label, tableLinks }: TableProps) => {
  return (
    <Box
      minWidth="161px"
      height="min-content"
      display={['none', 'none', 'block']}
      position="sticky"
      top={'124px'}
      ml={2}
    >
      <Text variant="kicker" mb={3}>
        {label}
      </Text>
      <Navigation>
        <Stack space={2.5} flexDirection="column">
          {tableLinks.map(({ link, label }) => (
            <Button
              variant="unstyled"
              to={link}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();

                document
                  .querySelector(`#${link.split('#')?.[1]}`)
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {label}
            </Button>
            // <NavigationLink
            //   link={link}
            //   color="grey200"
            //   fontSize="15px"
            //   lineHeight="12px"
            // >
            //   {label}
            // </NavigationLink>
          ))}
        </Stack>
      </Navigation>
    </Box>
  );
};
